import { Editor, Path, Transforms } from '@lumapps/wrex/slate';

import { isLink } from './isLink';

export const unwrapLink = (editor: Editor, nodePath?: Path) => {
    Transforms.unwrapNodes(editor, { match: isLink, at: nodePath });
};
